// extracted by mini-css-extract-plugin
export default {"slide":"slide_slide__71vy6","slideContent":"slide_slideContent__iTpyY","title":"slide_title__ZTkUV"};